import axios from 'axios';
import React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Input,
  InputGroup,
  Table,
} from 'reactstrap';
import NavBar from '../components/NavBar';
import { URL_NEW_MAPA_API } from '../config/urls';

class Contratos extends React.Component {
  constructor(props) {
    super(props);
    document.title = 'Contratos';
    this.state = {
      usuarioLogado: '',
      selectedContract: '',
      contracts: [],
      expandedRows: {},
      loading: true,
    };
  }

  async componentDidMount() {
    if (sessionStorage.getItem('usuarioLogado')) {
      const userInfo = JSON.parse(sessionStorage.getItem('usuarioLogado'))[0];

      this.setState({ usuarioLogado: userInfo });
      await this.fetchContracts(userInfo.idUsuario);
    }
  }

  toBRDate(dateString) {
    if (dateString === null) return '-';

    const date = new Date(dateString);

    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).format(date);
  }

  toggleRow(contractId) {
    this.setState((prevState) => ({
      expandedRows: {
        ...prevState.expandedRows,
        [contractId]: !prevState.expandedRows[contractId],
      },
    }));
  }

  async forceComplete(contractNumber) {
    if (!window.confirm(`Confirma a conclusão forçada do contrato ${contractNumber}?\n\nIsso vai finalizar o contrato e gerar o acesso no sistema da agência, mesmo sem todas as assinaturas.`)) {
      return;
    }

    try {
      await axios.post(
        `${URL_NEW_MAPA_API}/contracts/number/${contractNumber}/force-complete`,
        {},
        {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer 3bca4df63f1cc72e4c8ad364a5d426f77e65f5084b40be712cf0bc4ed34ac61e',
          },
        }
      );

      toast.success('Contrato concluído com sucesso! O acesso será gerado em breve.');

      const userId = this.state.usuarioLogado.idUsuario;
      if (this.state.selectedContract) {
        await this.fetchContract();
      } else {
        await this.fetchContracts(userId);
      }
    } catch (error) {
      const msg = (error.response && error.response.data && error.response.data.error) || 'Não foi possível concluir o contrato.';
      toast.error(msg);
    }
  }

  copyToClipboard(text) {
    navigator.clipboard.writeText(text).then(
      () => {
        toast.success('Link copiado para a área de transferência!');
      },
      () => {
        toast.error('Erro ao copiar o link!');
      }
    );
  }

  handleSearchKeyPress(e) {
    if (e.key === 'Enter') {
      this.fetchContract();
    }
  }

  clearSearch() {
    this.setState({ selectedContract: '', contracts: [] }, () => {
      if (this.state.usuarioLogado.idUsuario) {
        this.fetchContracts(this.state.usuarioLogado.idUsuario);
      }
    });
  }

  async fetchContract() {
    if (this.state.selectedContract.length < 3) {
      toast.error('Digite um número de contrato válido (mínimo 3 caracteres)');
      return;
    }

    this.setState({ loading: true });
    axios
      .get(
        URL_NEW_MAPA_API + `/contracts/number/${this.state.selectedContract}`,
        {
          headers: {
            Accept: 'application/json',
            Authorization:
              'Bearer 3bca4df63f1cc72e4c8ad364a5d426f77e65f5084b40be712cf0bc4ed34ac61e',
          },
        }
      )
      .then((response) => {
        const contract = response.data.contract;
        const total = contract.signers.length;
        const completed = contract.signers.filter((s) => s.status === 'signed')
          .length;

        const formattedContract = {
          ...contract,
          sent_at: this.toBRDate(contract.sent_at),
          signed_at: this.toBRDate(contract.signed_at),
          signersStatus: `${completed}/${total}`,
          status: contract.status === 'signed' ? 'Assinado' : 'Pendente',
        };

        this.setState({ contracts: [formattedContract], loading: false });
      })
      .catch((error) => {
        console.log(error);
        toast.info(
          error.response.status === 404
            ? 'Nenhum contrato foi encontrado!'
            : 'Não foi possível buscar os contratos. Tente novamente!'
        );
        this.setState({ loading: false, contracts: [] });
      });
  }

  async fetchContracts(userId) {
    this.setState({ loading: true });
    axios
      .get(URL_NEW_MAPA_API + `/contracts/${userId}/signature-status`, {
        headers: {
          Accept: 'application/json',
          Authorization:
            'Bearer 3bca4df63f1cc72e4c8ad364a5d426f77e65f5084b40be712cf0bc4ed34ac61e',
        },
      })
      .then((response) => {
        const contracts = response.data.contracts.map((c) => {
          const total = c.signers.length;
          const completed = c.signers.filter((s) => s.status === 'signed')
            .length;

          return {
            ...c,
            sent_at: this.toBRDate(c.sent_at),
            signed_at: this.toBRDate(c.signed_at),
            signersStatus: `${completed}/${total}`,
            status: c.status === 'signed' ? 'Assinado' : 'Pendente',
          };
        });

        this.setState({ contracts, loading: false });
      })
      .catch(() => {
        toast.error('Não foi possível buscar os contratos. Tente novamente!');
        this.setState({ loading: false });
      });
  }

  renderLoadingScreen() {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '400px',
          padding: '40px',
        }}
      >
        <style>
          {`
            @keyframes pulse {
              0%, 100% {
                transform: scale(1);
                opacity: 1;
              }
              50% {
                transform: scale(1.1);
                opacity: 0.8;
              }
            }
            @keyframes spin {
              from {
                transform: rotate(0deg);
              }
              to {
                transform: rotate(360deg);
              }
            }
            @keyframes fadeIn {
              from {
                opacity: 0;
                transform: translateY(10px);
              }
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }
          `}
        </style>
        <div
          style={{
            width: '80px',
            height: '80px',
            border: '6px solid #e9ecef',
            borderTop: '6px solid #007bff',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            marginBottom: '30px',
          }}
        ></div>
        <h4
          style={{
            color: '#495057',
            marginBottom: '10px',
            animation: 'fadeIn 0.5s ease-in',
            fontWeight: '600',
          }}
        >
          Buscando contratos...
        </h4>
        <p
          style={{
            color: '#6c757d',
            fontSize: '14px',
            animation: 'fadeIn 0.7s ease-in',
            textAlign: 'center',
          }}
        >
          Estamos consultando os dados na ZapSign
        </p>
        <div
          style={{
            display: 'flex',
            gap: '8px',
            marginTop: '20px',
          }}
        >
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              style={{
                width: '12px',
                height: '12px',
                backgroundColor: '#007bff',
                borderRadius: '50%',
                animation: 'pulse 1.5s ease-in-out infinite',
                animationDelay: `${i * 0.2}s`,
              }}
            ></div>
          ))}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div
        style={{
          backgroundColor: '#f5f4f9',
          paddingBottom: 30,
          position: 'relative',
          minHeight: '100vh',
        }}
      >
        <ToastContainer
          position='bottom-left'
          autoClose={5000}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange={false}
          draggable={false}
        />
        <NavBar
          className='no-print'
          nome={this.state.usuarioLogado.Nome}
          funcao={this.state.usuarioLogado.Funcao}
        />
        <div className='container-fluid'>
          <Card
            style={{
              boxShadow:
                '0.5rem 0.5rem 2rem 0 rgb(8 15 41 / 8%), 0 0 1px 0 rgb(8 15 41 / 8%)',
              borderRadius: '.375rem',
              marginTop: '20px',
              maxHeight: 'calc(100vh - 106px)',
              overflow: 'auto',
            }}
          >
            <CardHeader
              style={{
                borderBottom: 'none',
                backgroundColor: 'white',
                borderRadius: '.375rem',
                padding: '20px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',
                  gap: '15px',
                }}
              >
                <h5 style={{ margin: 0, fontWeight: '600' }}>
                  CONTRATOS GERADOS
                </h5>
                <div
                  style={{ display: 'flex', gap: '10px', flex: '0 1 400px' }}
                >
                  <InputGroup>
                    <Input
                      type='text'
                      placeholder='Digite o número do contrato...'
                      value={this.state.selectedContract}
                      onChange={(e) =>
                        this.setState({ selectedContract: e.target.value })
                      }
                      onKeyPress={(e) => this.handleSearchKeyPress(e)}
                      style={{
                        borderRadius: '4px 0 0 4px',
                      }}
                    />
                    {this.state.selectedContract && (
                      <Button
                        color='secondary'
                        onClick={() => this.clearSearch()}
                        style={{
                          borderRadius: '0',
                          padding: '0 12px',
                        }}
                        title='Limpar pesquisa'
                      >
                        <i className='fa fa-times'></i>
                      </Button>
                    )}
                    <Button
                      color='primary'
                      onClick={() => this.fetchContract()}
                      style={{
                        borderRadius: this.state.selectedContract
                          ? '0 4px 4px 0'
                          : '0 4px 4px 0',
                      }}
                    >
                      <i className='fa fa-search'></i> Buscar
                    </Button>
                  </InputGroup>
                </div>
              </div>
            </CardHeader>
            <CardBody style={{ marginTop: 0, paddingTop: 0 }}>
              {this.state.loading ? (
                this.renderLoadingScreen()
              ) : (
                <div className='table-responsive'>
                  <Table hover size='sm'>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Assinaturas</th>
                        <th>Dt. Criação</th>
                        <th>Dt. Finalização</th>
                      </tr>
                    </thead>
                    <tbody style={{ height: '100px', overflowY: 'scroll' }}>
                      {this.state.contracts.length === 0 ? (
                        <tr>
                          <td colSpan={4}>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                              }}
                            >
                              Não há dados para exibir
                            </div>
                          </td>
                        </tr>
                      ) : (
                        <React.Fragment>
                          {this.state.contracts.map((c) => (
                            <React.Fragment key={c.id}>
                              <tr onClick={() => this.toggleRow(c.id)}>
                                <td
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                  }}
                                >
                                  <span
                                    style={{
                                      display: 'inline-block',
                                      transition: 'transform 0.2s',
                                      transform: this.state.expandedRows[c.id]
                                        ? 'rotate(90deg)'
                                        : 'rotate(0deg)',
                                    }}
                                  >
                                    <i className='fa fa-chevron-right'></i>
                                  </span>
                                  {c.title}
                                </td>
                                <td>
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '15px',
                                    }}
                                  >
                                    {c.signersStatus}
                                    <span
                                      style={{
                                        backgroundColor: `${
                                          c.status === 'Assinado'
                                            ? '#28a745'
                                            : '#ffc107'
                                        }`,
                                        borderRadius: 20,
                                        color: 'white',
                                        fontSize: '10px',
                                        padding: '4px 8px',
                                      }}
                                    >
                                      {c.status}
                                    </span>
                                  </div>
                                </td>
                                <td>{c.sent_at}</td>
                                <td>
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    {c.signed_at}
                                    {c.status === 'Pendente' &&
                                      this.state.usuarioLogado.Funcao !== 'VENDEDOR' &&
                                      this.state.usuarioLogado.Nivel !== 'RESTRITO' && (
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          this.forceComplete(c.contract_number);
                                        }}
                                        style={{
                                          backgroundColor: '#dc3545',
                                          color: 'white',
                                          border: 'none',
                                          borderRadius: '4px',
                                          padding: '3px 8px',
                                          cursor: 'pointer',
                                          fontSize: '11px',
                                          whiteSpace: 'nowrap',
                                        }}
                                        title='Forçar conclusão do contrato mesmo sem todas as assinaturas'
                                      >
                                        Forçar Conclusão
                                      </button>
                                    )}
                                  </div>
                                </td>
                              </tr>
                              {this.state.expandedRows[c.id] && (
                                <tr>
                                  <td colSpan='5' style={{ padding: 0 }}>
                                    <div
                                      style={{
                                        backgroundColor: '#f8f9fa',
                                        padding: '15px',
                                      }}
                                    >
                                      <h6 style={{ marginBottom: '15px' }}>
                                        Assinantes
                                      </h6>
                                      <Table size='sm' bordered>
                                        <thead>
                                          <tr
                                            style={{
                                              backgroundColor: 'white',
                                            }}
                                          >
                                            <th>Nome</th>
                                            <th>Dt. Assinatura</th>
                                            <th>Link de Assinatura</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {c.signers.map((signer, idx) => (
                                            <tr
                                              key={idx}
                                              style={{
                                                backgroundColor: 'white',
                                              }}
                                            >
                                              <td>
                                                <div
                                                  style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                  }}
                                                >
                                                  {signer.name}
                                                  <small>{signer.email}</small>
                                                </div>
                                              </td>
                                              <td>
                                                {this.toBRDate(
                                                  signer.signed_at
                                                )}
                                              </td>
                                              <td>
                                                <button
                                                  onClick={() =>
                                                    this.copyToClipboard(
                                                      signer.sign_url
                                                    )
                                                  }
                                                  style={{
                                                    backgroundColor: '#007bff',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '4px',
                                                    padding: '5px 10px',
                                                    cursor: 'pointer',
                                                    fontSize: '12px',
                                                  }}
                                                  title={signer.sign_url}
                                                >
                                                  Copiar Link
                                                </button>
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </Table>
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          ))}
                        </React.Fragment>
                      )}
                    </tbody>
                  </Table>
                </div>
              )}
            </CardBody>
          </Card>
        </div>
      </div>
    );
  }
}

export default Contratos;
